module.exports = __webpack_public_path__ + "img/example_print_step1.bc61482f.png";